<template>
    <a-row :gutter="20">
      <a-col :span="6"  class="voice-panel voice-panel2">
          <div class="form-item" v-for="(item,index) in data" :key="index">
            <div class="row">
              {{item.formName}}
            </div>
            <div class="row">
              <div>
                原始答案：
              </div>
              <div>
                <voice-item-input :data="item" :keyStr="'value'"></voice-item-input>
              </div>
            </div>
            <div class="row">
              <div>
                语音核查答案：
              </div>
              <div>
                <voice-item-input :data="item" :keyStr="'voiceValue'"></voice-item-input>
              </div>
            </div>

          </div>
      </a-col>
      <a-col :span="12"  >
        <check-form class="voice-panel voice-panel2" :formId="formId" :showTitle="false" :showFile="false"></check-form>
      </a-col>
      <a-col :span="6"  class="voice-panel voice-panel2">
        <a-tabs class="tabs" v-model="activeKey"  >
          <a-tab-pane  :key="index+''" :tab="modelName(item)" v-for="(item,index) in voiceNlp">
            <div v-html="item.result">

            </div>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
</template>

<script>
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import VoiceItemInput from './VoiceItemInput'
  import CheckForm from '../../../CheckForm'
  export default {
    name: 'Item4',
    components: { CheckForm, VoiceItemInput },
    props:{
      data:{
        type:Array,
        default:()=>{
          return []
        }
      },
      voiceNlp:{
        type:Array,
        default:()=>{
          return []
        }
      },
      formId:{
        type:String,
        default:""
      },
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        modelList:[],
        activeKey:'0'
      }
    },
    mounted(){
      getAction('/project/voiceConfig/listAll',{projectId:this.projectId,enabled:'1'}).then(res=>{
        if(res.success){
          this.modelList = res.result
        }
      })
    },
    methods:{
      modelName(record){
        let result = {}
        if(record && this.modelList.length>0){
          this.modelList.forEach(item=>{
            if(item.code==record.modelCode){
              result = item.name
            }
          })
        }
        return result
      },
    }
  }
</script>

<style scoped lang="less">
  .voice-panel{
    padding: 10px;
  }
  .voice-panel2{
    max-height: calc(100vh - 200px);
    overflow: auto;
  }
  .form-item{
    margin-top: 10px;
  }
  .left{
    min-height: 330px;
  }
  .item{
    margin-top: 10px;
  }
</style>